export interface ColorPickerChoice {
	id?: number;
	color?: string;
}
